"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _role = require("@/api/role/role");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      treeList: [],
      defaultProps: {
        children: "children",
        label: "name"
      },
      roleForm: {
        name: "",
        menuIds: [],
        provinceId: this.$route.query.id
      },
      editDialog: false,
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "角色名称"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "角色名称",
        prop: "name",
        isShow: true,
        width: "200"
      }, {
        name: "创建时间",
        prop: "createTime",
        isShow: true,
        width: "150"
      }],
      funBtns: [{
        size: "small",
        click: "addBtn",
        icon: "el-icon-circle-plus-outline",
        name: "新增",
        type: "primary"
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      options: [{
        name: "编辑",
        class: "edit",
        option: "modifyJurisdiction",
        span: 3
      }, {
        span: 3,
        option: "dels",
        class: "edit",
        name: "删除",
        field: {
          name: "isDefault",
          value: 0
        }
      }],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      }
    };
  },
  methods: {
    // 获取角色列表
    getRoleList: function getRoleList() {
      var _this = this;
      (0, _role.roleList)({
        name: this.queryValue,
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize,
        provinceId: this.$route.query.id
      }).then(function (res) {
        var data = res.data;
        _this.listData = data.list;
        _this.totalData = data.total;
      });
    },
    listBureau: function listBureau() {},
    morePublishout: function morePublishout() {},
    morePublish: function morePublish() {},
    dels: function dels(row) {
      var _this2 = this;
      this.$confirm("删除角色同时删除绑定的菜单权限，是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        (0, _role.removeRole)({
          id: row.id
        }).then(function (res) {
          if (res.code == 2000) {
            _this2.$message.success(res.msg);
            _this2.getRoleList();
          } else {
            _this2.$message.error(res.msg);
          }
        });
      });
    },
    // 新增
    addBtn: function addBtn() {
      this.insertOrUpdate("", "");
    },
    // 编辑角色权限
    modifyJurisdiction: function modifyJurisdiction(row) {
      this.insertOrUpdate(row.id, row.name);
    },
    insertOrUpdate: function insertOrUpdate(roleId, name) {
      var _this3 = this;
      (0, _role.getRoleMenuTreeListForRole)({
        roleId: roleId,
        provinceId: this.$route.query.id
      }).then(function (res) {
        _this3.roleForm.name = name;
        _this3.roleForm.roleId = roleId;
        if (res.code == 2000) {
          _this3.treeList = res.data;
          _this3.editDialog = true;
          _this3.roleForm.menuIds = [];
          (0, _role.getRoleMenuByRoleId)({
            roleId: roleId
          }).then(function (ress) {
            _this3.roleForm.menuIds = ress.data;
          });
        }
      });
    },
    nodeCheckChange: function nodeCheckChange(e, checked) {
      var _this4 = this;
      var children = e.children;
      var parentId = e.parentId;
      if (parentId != 0 && checked) {
        this.getNode(parentId);
      }
      if (!checked && children.length > 0) {
        children.forEach(function (item) {
          _this4.$refs.tree.setChecked(item.id, false, true);
        });
      }
    },
    getNode: function getNode(key) {
      var node = this.$refs.tree.getNode(key);
      console.log("node", node);
      if (node != null) {
        this.$refs.tree.setChecked(node.data.id, true);
        if (node.data.parentId != 0) {
          this.getNode(node.data.parentId);
        }
      }
      return false;
    },
    handleSelectionChange: function handleSelectionChange() {},
    deleteById: function deleteById() {},
    distribution: function distribution() {},
    viewAdmin: function viewAdmin() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getRoleList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getRoleList();
    },
    handleClose: function handleClose(done) {
      done();
    },
    editSubmit: function editSubmit() {
      var _this5 = this;
      if (this.roleForm.name.trim() == "") {
        this.$message({
          message: "请输入角色名称",
          type: "warning"
        });
        return false;
      }
      this.roleForm.menuIds = this.$refs.tree.getCheckedKeys();
      (0, _role.insertRoleMenu)(_objectSpread({}, this.roleForm)).then(function (res) {
        if (res.code == 2000) {
          _this5.$message({
            message: "操作成功！",
            type: "success"
          });
          _this5.editDialog = false;
          _this5.getRoleList();
        } else {
          _this5.$message({
            message: "操作失败！",
            type: "error"
          });
        }
      });
    }
  },
  created: function created() {
    this.getRoleList();
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};